import { Component, OnInit } from '@angular/core';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';
import { StatisticService } from '@fi-shared/statistic/statistic.service';
import { ModuleType } from '@fi-shared/types';

@Component({
    selector: 'fi-customer-billing-customer-list-state',
    template: ` <fi-customer-billing-customer-list> </fi-customer-billing-customer-list> `,
    standalone: false,
})
export class CustomerBillingCustomerListStateComponent implements OnInit {
    constructor(
        private tabsModuleService: TabsModuleService,
        private statisticService: StatisticService,
    ) {}

    ngOnInit(): void {
        this.statisticService.Visit(ModuleType.Billing);
    }
}
